import { render, staticRenderFns } from "./veStuChangeZyEdit.vue?vue&type=template&id=8de972e6&scoped=true"
import script from "./veStuChangeZyEdit.vue?vue&type=script&lang=js"
export * from "./veStuChangeZyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de972e6",
  null
  
)

export default component.exports